import { render, staticRenderFns } from "./FeaturedCampaign.vue?vue&type=template&id=eca7bf4e"
import script from "./FeaturedCampaign.vue?vue&type=script&lang=js"
export * from "./FeaturedCampaign.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCampaign.vue?vue&type=style&index=0&id=eca7bf4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports